import { useEffect, useState, useRef } from 'react';

import axios from "axios";
import { SERVER , EMAILFROM} from "../../keyvariable";

import React from 'react';
import {DragAndDrop, Resize, ScheduleComponent, ResourcesDirective, ResourceDirective, ViewsDirective, ViewDirective, Day, Week, WorkWeek, Month, Inject,formatDate, cellClick, Agenda  } from '@syncfusion/ej2-react-schedule';
import { Internationalization, L10n, extend } from '@syncfusion/ej2-base';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import AdminMenu from '../../components/adminmenu';

L10n.load({
  'en-US': {
    'schedule': {
      'newEvent': 'Personal Information',
    },
  }
});

const Schedule = ()=>{
 
  const [agendas, setAgenda] = useState([]);
  const PhilippinesTimeZone = "Asia/Manila";
  
   var Purpose
   var Prefix
   var Name
   var StartTime
   var EndTime
   var Companyname
   var Email
   var Phonenumber
   var Description
   var Status
   var Notes
  


  const editForm = ()=>{

     Purpose = document.getElementById("purpose").value
     Prefix = document.getElementById("prefix").value
     Status = document.getElementById("status").value
     Name =  document.getElementById("name").value
     Companyname =  document.getElementById("cname").value
     Email =  document.getElementById("email").value
     Phonenumber =  document.getElementById("phoneNumber").value
     Description =  document.getElementById("description").value
     Notes =  document.getElementById("note").value

  }

  const [contact, setContact] =  useState({
    from: `SCHEDULE APPOINTMENT ${EMAILFROM}`,
      to: "", 
      subject: "Euodoo Technologies Inc. Schedule Appointment",
      html:""
  })

  const intl = new Internationalization();
  
  useEffect(()=>{
    axios.get(SERVER+"schedule").then(res=>{
      setAgenda(res.data);
    }).catch(err => console.log(err))
  },[])
 
  const eventSettings = { dataSource: agendas,  };

  function handleEventRendered (args) {
    const statusColor = {
      'Pending': '#e3165b',
      'Confirmed': 'rgb(163, 38, 163)', 
    };
    
    args.element.style.backgroundColor = statusColor[args.data.Status];
  }

  const handleActionComplete = (args)=>{
      if (args.requestType === 'eventCreate') {
        const details={
          Subject: args.data[0].Subject,
          Prefix: document.getElementById("prefix").value,
          Name: document.getElementById("name").value,
          StartTime: args.data[0].StartTime,
          EndTime: args.data[0].EndTime,
          Companyname: document.getElementById("cname").value,
          Email: document.getElementById("email").value,
          Phonenumber: document.getElementById("phoneNumber").value,
          Status: document.getElementById("status").value,
          Description: document.getElementById("description").value,
          Note: document.getElementById("note").value,
          isSlotAvailable: false
        }
          axios.post(SERVER+"schedule", details).then(()=>{
            axios.get(SERVER+"schedule").then((res)=>{setAgenda(res.data)})
           
          })

          if (args.data.Status === 'Confirm') {
            const contactForm = {
              from : contact.from,
              to : args.data.Email,
              subject: contact.subject,
              html: `
              
                  <div class="card container">
                    <div class="card-body">
                      <p class="card-title">Dear ${args.data.Name}, </p>
                      <p class="card-text">We received your request of a scheduled appointment for the purpose of ${args.data.Subject}. 
                      We are pleased to inform you that your request for an appointment has been confirmed. Please note that this message is auto generated and our sales and marketing team will
                      contact you shortly to send details of the meeting. </p>
                      <p class="card-text">If you have any questions please feel free to contact us and in case of rescheduling refer to this link: www.euodoo.com.ph/schedule</p>
                    </div>
                    <div class="card-footer">
                        <br/>
                        © 2023 | Euodoo Technologies Inc., 10/F One Global Place 25th Street cor. 5th Avenue Bonifacio Global City, 
                        Taguig 1632 Philippines | www.euodoo.com.ph
                    </div>
                  </div>
              
              `
          }
      
            axios.post(SERVER + "send", contactForm)
          }
      }else if (args.requestType === 'eventChange') {
       axios.put(SERVER+"schedule/"+args.data._id, args.data).then(()=>{
        axios.get(SERVER+"schedule").then(res=>setAgenda(res.data))
        })

       if (args.data.Status === 'Declined'){
          try{
            const contactForm = {
              from : contact.from,
              to : args.data.Email,
              subject: contact.subject,
              html: `
              
                  <div class="card container">
                    <div class="card-body">
                      <p class="card-title">Dear ${args.data.Name}, </p>
                      <p class="card-text">We received your request of a scheduled appointment for the purpose of ${args.data.Subject}. 
                      We regret to inform you that your request for an appointment was declined. The decision of declining your request was ${args.data.Note}.
                      <p class="card-text">Please note that this email is auto generated. If you have any questions please feel free to contact us and in case of rescheduling refer to this link: www.euodoo.com.ph/schedule</p>
                    </div>
                    <div class="card-footer">
                        <br/>
                        © 2023 | Euodoo Technologies Inc., 10/F One Global Place 25th Street cor. 5th Avenue Bonifacio Global City, 
                        Taguig 1632 Philippines | www.euodoo.com.ph
                    </div>
                  </div>
              
              `
            }
            axios.post(SERVER + "send", contactForm)
            axios.delete(SERVER+"schedule/"+args.data._id);
              const updatedAppointments = agendas.filter(
                (appointment) => appointment._id !== args.data._id
              );
              setAgenda(updatedAppointments);
            } catch (error) {
              console.error('Error deleting appointment:', error);
          }
       }
       else if (args.data.Status === 'Confirmed') {
        const contactForm = {
          from : contact.from,
          to : args.data.Email,
          subject: contact.subject,
          html: `
          
            <div class="card container">
            <div class="card-body">
              <p class="card-title">Dear ${args.data.Name}, </p>
              <p class="card-text">We received your request of a schedule appointment for the purpose of ${args.data.Subject}. 
              We are pleased to inform you that your request for appointment has been confirmed. Please note that this message is auto generated and our sales and marketing team will
              contact you shortly to send details of the meeting. </p>
              <p class="card-text">If you have any questions pleae feel free to contact us and in case of rescheduling refer to this link: www.euodoo.com.ph/schedule</p>
            </div>
            <div class="card-footer">
                <br/>
                © 2023 | Euodoo Technologies Inc., 10/F One Global Place 25th Street cor. 5th Avenue Bonifacio Global City, 
                Taguig 1632 Philippines | www.euodoo.com.ph
            </div>
          </div>
          
          `
      }
  
        axios.post(SERVER + "send", contactForm)
      }
          
      }else if (args.requestType === 'eventRemove') {
          try {
            axios.delete(SERVER+"schedule/"+args.data[0]._id);
            const updatedAppointments = agendas.filter(
              (appointment) => appointment._id !== args.data[0]._id
            );
            setAgenda(updatedAppointments);
          } catch (error) {
            console.error('Error deleting appointment:', error);
          }
      }  
  }

  const onCellTemplate = (props) => {
    
    const { date } = props;

    const lunchBreakStartTime = new Date(date);
    lunchBreakStartTime.setHours(12, 0, 0);

    const lunchBreakEndTime = new Date(date);
    lunchBreakEndTime.setHours(13, 0, 0);

    const isLunchBreak = date >= lunchBreakStartTime && date < lunchBreakEndTime;

    if (isLunchBreak) {
      return (
        <div className='lunch-break' style={{ pointerEvents: 'none', }}>
        <br/>
        <span style={{ fontWeight: '500'}}>Break</span>
        </div>
      );
      
    }
  }

  const timeScale = { enable: true, interval: 60, slotCount: 1};

  //for more details
  function editorTemplate(props) {
    return (props !== undefined ?<table className="custom-event-editor" ><tbody>
    <tr><td className="e-textlabel">Purpose </td><td colSpan={4}>
        <input defaultValue={props.Subject} onChange={editForm} id="purpose" className="e-field e-input" type="text" name="Subject" />
      </td></tr>
      <tr><td className="e-textlabel">Prefix</td><td colSpan={4}>
        <DropDownListComponent value={props.Prefix} id="prefix" name="Prefix" className="e-field" dataSource={['Mr.', 'Ms.']}></DropDownListComponent>
      </td></tr>
      <tr><td className="e-textlabel">Full Name</td><td colSpan={4}>
        <input defaultValue={props.Name} onChange={editForm}  id="name" className="e-field e-input" name="Name" colSpan={4}></input>
      </td></tr>
      <tr><td className="e-textlabel">Status</td><td colSpan={4}>
        <DropDownListComponent value={props.Status} id="status" placeholder='Choose status' name="Status" className="e-field" dataSource={['Pending', 'Confirmed', 'Declined']}></DropDownListComponent>
      </td></tr>
      <tr><td className="e-textlabel">Note (for declined status)</td><td colSpan={4}>
        <input defaultValue={props.Note} onChange={editForm}  id="note" className="e-field e-input" name="Note" colSpan={4}></input>
      </td></tr>
      <tr><td className="e-textlabel">From</td><td colSpan={4}>
        <DateTimePickerComponent step={60} format='dd/MM/yy hh:mm a' id="StartTime" name="StartTime" value={new Date(props.startTime || props.StartTime)} className="e-field"></DateTimePickerComponent>
      </td></tr>
      <tr><td className="e-textlabel">To</td><td colSpan={4}>
        <DateTimePickerComponent step={60} format='dd/MM/yy hh:mm a' id="EndTime" name="EndTime" value={new Date(props.endTime || props.EndTime)} className="e-field"></DateTimePickerComponent>
      </td></tr>
      <tr><td className="e-textlabel">Company Name</td><td colSpan={4}>
      <input defaultValue={props.Companyname} onChange={editForm} id="cname" className="e-field e-input" name="Companyname" colSpan={4}></input>
      </td></tr>
      <tr><td className="e-textlabel">Email</td><td colSpan={4}>
      <input defaultValue={props.Email} onChange={editForm} id="email" className="e-field e-input" type="email" name="Email"/>
      </td></tr>
      <tr><td className="e-textlabel">Phone Number</td><td colSpan={4}>
      <input defaultValue={props.Phonenumber} onChange={editForm} id="phoneNumber" className="e-field e-input" type="number" name="Phonenumber"  />
      </td></tr>
      <tr><td className="e-textlabel">Description</td><td colSpan={4}>
      <textarea defaultValue={props.Description} onChange={editForm} id="description" className="e-field e-input" type="text" name="Description"  />
      </td></tr>
      </tbody></table>
       : <div></div>);
  }

  //disable double click showing editor
  function onCellDoubleClick (args) {
    args.cancel = true;
  }

  const isBreak = (startDate, endDate) => {
    const lunchBreakStartTime = new Date(startDate);
    lunchBreakStartTime.setHours(12, 0, 0);

    const lunchBreakEndTime = new Date(endDate);
    lunchBreakEndTime.setHours(13, 0, 0);
    return (startDate.getTime() >= lunchBreakStartTime && endDate.getTime() <= lunchBreakEndTime);
  }

  function onPopupOpen(args) { 
    let headerCell = args.element.querySelector('e-header-cells') // prevents clicking in header cell
    if ((args.type === 'QuickInfo' || args.type === 'Editor') && headerCell) { 
      args.cancel = true; 
    }

    if (args.type === 'QuickInfo' || args.type === 'Editor') //to disable past time
    {
      if (isBreak(args.data.StartTime, args.data.EndTime)) {

        alert("Please choose an appropriate time.");
        args.cancel = true;
      }
    } 

    if(args.type === 'QuickInfo') { 
      if(args.element.querySelector('.e-cell-popup')){
        args.element.querySelector('.e-event-create').style.display = 'none'; 
      }
      else if (args.element.querySelector('e-event-popup')){
        return
      }
    } 

    if (args.type === "Editor") {
      const formElement = args.element.querySelector(".e-schedule-form")
      formElement.ej2_instances[0].addRules('Subject', { required: true });
      formElement.ej2_instances[0].addRules('Status', { required: true });
      formElement.ej2_instances[0].addRules('Prefix', { required: true });
      formElement.ej2_instances[0].addRules('Name', { required: true }); 
      formElement.ej2_instances[0].addRules('StartTime', { required: true }); 
      formElement.ej2_instances[0].addRules('EndTime', { required: true }); 
      formElement.ej2_instances[0].addRules('Companyname', { required: true });
      formElement.ej2_instances[0].addRules('Email', { required: true, email: true }); 
      formElement.ej2_instances[0].addRules('Phonenumber', { required: true, digits: true, maxLength: 11, minLength: 10 }); 
    }
    
  } 

  const contentTemplate = (props) => {
    return (
    
    <div className="quick-info-content">
      {props.elementType === 'cell' ?
       <div>
        
       </div>
        :
        <div className="event-content">
          <div className="meeting-subject-wrap">
            <label>Purpose</label>:
            <span>{props.Subject}</span>
          </div>
          <div className="meeting-subject-wrap">
            <label>Prefix</label>:
            <span>{props.Prefix}</span>
          </div>
          <div className="meeting-type-wrap">
            <label>Name</label>:
            <span>{props.Name}</span>
          </div>
          <div className="meeting-type-wrap">
            <label>Company Name</label>:
            <span>{props.Companyname}</span>
          </div>
          <div className="meeting-subject-wrap">
            <label>Email Address</label>:
            <span>{props.Email}</span>
          </div>
          <div className="notes-wrap">
            <label>Phone Number</label>:
            <span>{props.Phonenumber}</span>
          </div>
        </div>
        }
    </div>);
  }

  const headerTemplate = (props) => {
    return (<div className="quick-info-header">
      <div className="quick-info-header-content" style={getHeaderStyles(props)}>
        <div className="quick-info-title">{getHeaderTitle(props)}</div>
        <div className="duration-text">{getHeaderDetails(props)}</div>
      </div>
    </div>);
  }
  const getHeaderStyles = (data) => {
    if (data.elementType === 'cell') {
      return { textAlign: 'center', background: '#e3165b',color: 'white', fontSize: '12px', margin: '20px 20px 0 20px', padding: '15px'};
    }
    else {
      const statusColor = {
        'Pending': '#e3165b',
        'Confirmed': 'rgb(163, 38, 163)',
      }
      return { background: statusColor[data.Status], color: '#FFFFFF', fontSize: '12px', margin: '20px 20px 0 20px', padding: '15px' };

    }
  }
  const getHeaderTitle = (data) => {
    return (data.elementType === 'cell') ? 'Add Appointment' : 'Appointment Details';
  }
  const getHeaderDetails = (data) => {
    return intl.formatDate(data.StartTime, { type: 'date', skeleton: 'full' }) + ' (' +
      intl.formatDate(data.StartTime, { skeleton: 'hm' }) + ' - ' +
      intl.formatDate(data.EndTime, { skeleton: 'hm' }) + ')';
  }


  const quickInfoTemplates ={
    header: headerTemplate,
    content: contentTemplate,
  }


  return(
    <div>
      <AdminMenu/>
      <div className='side-content pt-5 mt-5 mt-md-5 pt-md-4'>
        <div className="container" style={{minHeight: "80vh", paddingBottom: "100px"}}>
          <div className='schedule-admin-legends'>
            <h5 style={{textAlign:'center'}}>Legends</h5>
            <p style={{textAlign:'center', fontStyle: 'italic', color:'red'}}>Note: An auto-generated email will be sent on the client's email depending on the status of the appointment.</p>
            <div className=' row  color-status'>
            <div className='col-sm-12 col-lg-2 col-md-6' style={{display: 'flex', float: 'left'}}>
              <div className="Pending-box"></div>
              <p className='status-p'>Pending</p>
            </div>
            <div className='col-sm-12 col-lg-2 col-md-6' style={{display: 'flex', float: 'left'}}>
              <div className="Approved-box"></div>
              <p className='status-p'>Confirmed</p>
            </div>
            <div className='col-sm-12 col-lg-3 col-md-12' style={{display: 'flex', float: 'left'}}>
              <div className="Denied-box"></div>
              <p className='status-p'>Declined <small>(Delete data)</small></p>
            </div>
            </div>
          </div>

        <ScheduleComponent 
          width='100%'
          height='493px'
          selectedDate={new Date()}
          actionBegin={handleActionComplete}
          eventSettings ={eventSettings} 
          eventRendered={handleEventRendered}
          startHour='10:00' 
          endHour='17:00'
          timeScale={timeScale}
          editorTemplate={editorTemplate}
          cellDoubleClick={onCellDoubleClick}
          popupOpen={onPopupOpen}
          quickInfoTemplates={quickInfoTemplates}
          enablePersistence={true}
          cellTemplate={onCellTemplate}
          timezone={PhilippinesTimeZone} 
        
        >
          <ViewsDirective >
            <ViewDirective option='WorkWeek' />
          </ViewsDirective>
          <Inject services={[ WorkWeek, DragAndDrop, Resize]} />
        </ScheduleComponent>
        </div>
      </div>
      
    </div>
    
  )
 }
  
 export default Schedule;